import { render } from "./BaSummary.vue?vue&type=template&id=65593114&scoped=true&ts=true"
import script from "./BaSummary.vue?vue&type=script&lang=ts"
export * from "./BaSummary.vue?vue&type=script&lang=ts"

import "./BaSummary.vue?vue&type=style&index=0&id=65593114&scoped=true&lang=css"

import exportComponent from "/home/ben/work/acon/acon-360/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65593114"]])

export default __exports__